import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import Question from "./Question";

export default function Questions({ test, setTest, loadNextQuestion }) {
    const navigate = useNavigate();

    return (
        <div className="relative z-1 flex flex-column py-2">
            <Question
                test={test}
                setTest={setTest}
                currentQuestion={test?.currentQuestion}
                loadNextQuestion={loadNextQuestion}
                {...test?.questions?.[test?.currentQuestion]}
            />
            <div className="flex align-items-center justify-content-between gap-2 px-3 pt-2 pb-3">
                <Button label="Cancel" size="small" severity="danger" outlined icon="pi pi-times" iconPos="left" onClick={() => navigate(-1)} />
                <Button
                    size="small"
                    label="Skip"
                    severity="warning"
                    outlined
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    onClick={() => {
                        setTest((prev) => ({ ...prev, skip: (prev?.skip || 0) + 1 }));
                        loadNextQuestion();
                    }}
                />
            </div>
        </div>
    );
}
